// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"8b0017d1","121":"000867b2","163":"2047336d","251":"a57c10ef","276":"97db391e","420":"e5e0bb80","460":"649e2c7b","606":"32d2e54a","693":"34d44055","767":"df638c53","848":"1543b7c0","916":"31f873b7","990":"3159f5f7"}[chunkId] + ".chunk.js";
};